var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapMarkerYellow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 23,
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.745 0h15.967v23H.745z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.474)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEB11F",
    d: "M8.714 10.917c1.562.02 2.844-1.25 2.86-2.832.017-1.59-1.229-2.886-2.789-2.904a2.842 2.842 0 00-2.9 2.818 2.843 2.843 0 002.829 2.918M8.717 23c-.466-.565-.924-1.101-1.362-1.654-1.91-2.4-3.66-4.907-5.015-7.674-.675-1.379-1.223-2.804-1.484-4.331C.282 5.983 1.975 2.528 4.986.939c4.768-2.515 10.516.25 11.58 5.573.31 1.546.1 3.052-.378 4.534-.672 2.08-1.706 3.981-2.867 5.815a50.807 50.807 0 01-4.477 6c-.029.034-.06.066-.127.139",
    mask: "url(#b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerYellow);
export default __webpack_public_path__ + "static/media/map-marker-yellow.acd3e258.svg";
export { ForwardRef as ReactComponent };